import React, { createContext, useContext } from 'react';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Box from '@mui/material/Box';

// Notification context to handle success and error messages
const NotificationContext = createContext();

export const useNotifications = () => {
    return useContext(NotificationContext);
};

const CustomToast = ({ message, color, closeToast }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '8px 16px',
            color: color.text,
            fontWeight: 600,
            minWidth: '150px',
            maxWidth: '250px',
            "& svg": { color: color.icon },
        }}
    >
        <Box sx={{ flexGrow: 1, textAlign: 'center', mr: 1 }}>{message}</Box>
    </Box>
);

export const NotificationProvider = ({ children }) => {
    const styles = {
        success: { text: '#07bc0c', icon: '#07bc0c', bg: '#fff' },
        error: { text: '#d32f2f', icon: '#d32f2f', bg: '#fff' },
        info: { text: '#1976d2', icon: '#1976d2', bg: '#fff' },
        warn: { text: '#f1c40f', icon: '#f1c40f', bg: '#fff' },
    };

    const showToast = (type, message) => {
        const toastFn = {
            success: toast.success,
            error: toast.error,
            info: toast.info,
            warn: toast.warn,
        }[type];

        if (toastFn) {
            toastFn(
                ({ closeToast }) => (
                    <CustomToast message={message} color={styles[type]} closeToast={closeToast} />
                ),
                {
                    toastId: message,
                    position: "top-right",
                    autoClose: 500,
                    draggable: true,
                    closeButton: false,
                    transition: Slide,
                    hideProgressBar: true,
                    style: {
                        backgroundColor: styles[type].bg,
                        borderRadius: '8px',
                        minWidth: '150px',
                        maxWidth: '250px',
                        margin: '0 auto',
                        boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
                    },
                }
            );
        }
    };

    return (
        <NotificationContext.Provider value={{
            success: (msg) => showToast('success', msg),
            error: (msg) => showToast('error', msg),
            info: (msg) => showToast('info', msg),
            warn: (msg) => showToast('warn', msg),
            dismissAll: () => toast.dismiss(),
        }}>
            <ToastContainer autoClose={500} draggable />
            {children}
        </NotificationContext.Provider>
    );
};
